import React, { useEffect, useState } from 'react';

import { BInputError, BRadio, BTextarea } from '../../../../components/ui/form';
import { requiredField } from '../../../../utils';

const PedagogicalPositioningField = ({ pedagogicalPositioning, register, name, errors }) => {
  const [type, setType] = useState(null);
  useEffect(() => {
    if (Array.isArray(pedagogicalPositioning.response) && pedagogicalPositioning.response.length > 0) {
      setType(pedagogicalPositioning.response[0].type);
    }
  }, [pedagogicalPositioning]);
  if (type === null) return;
  if (type === 'checkbox') {
    const tmp = pedagogicalPositioning.response.map((response, index) => {
      return (
        <div key={index} className="flex gap-2">
          <BRadio
            label={response.response}
            value={response.id}
            id={`value${response.id}`}
            {...register(name, { required: { value: true, message: requiredField } })}
          />
        </div>
      );
    });
    return (
      <div className={'flex flex-col gap-1'}>
        <p className={'text-sm font-normal text-slate-700'}>{pedagogicalPositioning.question}</p>
        <div className={'flex flex-col gap-1 sm:flex-row sm:gap-2'}>{tmp}</div>
        <BInputError errors={errors} />
      </div>
    );
  }
  if (type === 'text')
    return (
      <BTextarea
        minLength={100}
        maxLength={1000}
        errors={errors}
        label={pedagogicalPositioning.question}
        rows={4}
        placeholder={'Completez'}
        name={name}
        {...register(name, {
          required: { value: true, message: requiredField },
          minLength: { value: 100 },
          maxLength: { value: 1000, message: 'Au maximum 1000 caractères' },
        })}
      />
    );
};

export default PedagogicalPositioningField;
